import { Relations } from "@inrev/common";
import { Icon } from "@portal/components/primitives";
import { ToolIcon } from "@portal/components/ui/ToolIcon";

export const AdminAssistantIcon = ({
	relation: _relation,
	...rest
}: {
	relation: Relations.Notes;
}) => {
	return (
		<ToolIcon
			icon={<Icon size="mini" type="chat-bubble-oval-left" />}
			label="Assistant"
			{...rest}
		/>
	);
};
